import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useGenerateHlfReport = () => {
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const generateReport = async (params) => {
		const instance = await InitApi({ accessToken });
		const response = await instance.post("/hlf-reports/generate", params);
		return response.data;
	};

	return useMutation(generateReport, {
		onSuccess: async ({ data: body }) => {
			toast.success(body.message || "Report generated successfully!");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data?.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useGenerateHlfReport;
